import { CreateClientRequest, SpecialPackageData } from "../../types/client";
import { generateRandomNumber } from "../../utils/generateRandomNumber";

export const initialSpecialPackage: SpecialPackageData = {
    specialPackage: {
        depositAmount: 0,
        depositDate: '',
        receiptNumber: '',
        id: 0,
        name: "",
        categoryInfo: {
            categoryId: 0,
            categoryName: ''
        },
        sizeInfo: {
            size: '',
            sizeId: 0
        }
    },
    items: [],
    startDate: "",
    startTime: "",
    endDate: "",
    endTime: "",
};

export const initialContactPerson = [ 
    { 
        contactID: generateRandomNumber(), 
        name: '', 
        number: '09' 
    }
]

export const initialClientForm: CreateClientRequest = {
    deceasedName: '',
    registeredBy: '',
    mobileNo: '09',
    email: '',
    scheduleFrom: '',
    scheduleTo: '',
    startTime: '10:00',
    endTime: '',
    contactPersons: initialContactPerson,
    extraPackages: [],
    specialPackage: initialSpecialPackage,
    chapels: [],
};